import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import dictionary from "dict/static.json";
import {FilterParams} from "../../models/filter_form.model";
import * as qs from 'qs';
import merge from 'lodash-es/merge';
import {MailBodyModalComponent} from "./mail_body.component";
import {ModalService} from "../../views/modal/base_modal.component";
import { MailService } from "../mail.service";

interface IMailStatusBody {
	html: string;
}

@Component({
	selector: 'mail-status',
	templateUrl: './mail_status.component.html'
})
export class MailsStatusComponent extends BaseComponent {
	dictionary: any;

	addFilterParams = {
		dateFilters : ['dateSentMail']
	};
	
	stats: any;
	loader: boolean = false;

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public route: ActivatedRoute,
		public filter: FilterFormService,
		private modalService: ModalService,
		public mailService: MailService,
	) {
		super(eventsService, mailService, activatedRoute, filter, translate);

		let me = this;

		me.dictionary = dictionary;
	}

	async ngOnInit() {
		super.ngOnInit();
	}
	
	async getData() {
		this.loader = true;
		const { stats } = await this.mailService.mailStatus.stats(
			this.filter.filterParams
		).toPromise();
		this.stats = stats;
		
		this.loader = false;
	}

	async applyFilters() {
		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url    = this.router.url.split('?')[0];

		params = qs.stringify(params, { encode: false });

		this.router.navigateByUrl(`${url}?${params}`, { relativeTo: this.route });
	}


	async resetFilters() {
		this.filter.filterParams = new FilterParams();
		this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params: FilterParams = merge({}, this.filter.getDiffParams(this.filter.filterParams)),
			url = this.router.url.split('?')[0];

		delete params.dateFilters;
		delete params.dateFilterParams;

		this.router.navigate([url], { relativeTo: this.route, queryParams: params });
	}

	async showBody(id, event) {
		event.preventDefault();
		
		let modal = this.modalService.openEmpty(MailBodyModalComponent, {size: 'lg'});
		const { html } = await this.mailService.mailStatus.get<IMailStatusBody>(
			this.filter.filterParams,
			`body/${id}`
		).toPromise();
		
		const stat = this.stats.find(s => s._id == id);
		
		this.modalService.fillData(modal, {
			title: `<${stat.to}> ${stat.subject}`,
			body: html,
		}).result.then(() => {});
		
		return false;
	}
}
